<template>
    <v-layout class="v-card elevation-3 bn-tarifa-pages-section-container" :class="getClass" row wrap
              justify-space-between>
        <v-flex
            :style="style"
            class="bn-tarifa-pages-section-title headline bn-tarifa-pages-section-header-title"
            md12
        >
            <v-layout row wrap justify-space-between>
                <v-flex md11>
                    {{ blockTitle }}
                </v-flex>
                <v-flex md1>
                    <slot name="header-element"></slot>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex md12 class="pa-2">
            <v-layout row wrap justify-start>
                <v-flex md12>
                    <slot name="block-elements"> </slot>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>
<script>
import { COLOR_TYPE } from '../../modules/AppTheme';

export default {
    computed: {
        getClass() {
            return this.sectionFinished ? 'section-finished' : 'section-unfinished';
        },

        style() {
            // let color = this.$theme.getColor(COLOR_TYPE.SECONDARY)
            const color = this.sectionFinished
                ? this.$theme.getColor(COLOR_TYPE.SECONDARY) : this.$theme.getColor(COLOR_TYPE.PRIMARY);
            return {
                'background-color': color,
                color: 'white',
                padding: '10px',
                'font-size': '14px',
            };
        },
    },

    props: {
        blockTitle: {
            type: String,
            required: true,
        },

        sectionFinished: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style scoped>

    .bn-tarifa-pages-section-container {
        padding: 8px;
        margin: 15px;
    }

    .bn-tarifa-pages-section-title {
        font-size: 20px;
        padding: 10px;
    }

    .bn-tarifa-pages-section-title > .v-icon {
        color: white;
    }

    .must-select-text {
        position: relative;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
    .selected-item-text {
        position: relative;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
    .bn-tarifa-pages-section-header-title {
        width: 100%;
        font-weight: lighter;
        border-bottom: 2px solid;
    }
</style>
